import { BatchesService } from '@festina/legalentitydatareplicator-general-types/legalentitydatareplicator/services/BatchesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = BatchesService.batchesServiceDeleteDelete
type MethodParam = Parameters<typeof method>[0]

export const useDeleteLegalEntityDataReplicatorBatch = () =>
  useFestinaMutation({
    component: 'legalEntityDataReplicator',
    isScenario: false,
    roles: BatchesService.batchesServiceDeleteDelete_roles,
    mutateFunction: async (arg: MethodParam) => await method(arg),
  })
